<template>
    <div class="HomeWrap">
        <div class="SwiperWrap">
            <i class="LeftShadow"><img src="../../assets/Home/LeftShadow.png"></i>
            <swiper class="SwiperList" ref="mySwiper" :options="swiperOptions">
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img2.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img1.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img3.jpg"></swiper-slide>
                <div class="swiper-pagination flex" slot="pagination"></div>
            </swiper>
            <i class="RightShadow"><img src="../../assets/Home/RightShadow.png"></i>
        </div>
        <div class="HomeContentWrap">
            <div class="ListWrap flexa">
                <div  @click="OpenUrl('http://www.craftschina.cn/')"><img src="../../assets/Home/list7.jpg"></div>
                <div  @click="OpenUrl('http://www.guchengac.com/')"><img src="../../assets/Home/list8.jpg"></div>
                <div  @click="OpenUrl('http://www.91ghd.com/')"><img src="../../assets/Home/list21.jpg"></div>
                <div><img src="../../assets/Home/list22.jpg"></div>
                <router-link tag="div" :to="{name:'ProductList'}"><img src="../../assets/Home/list20.png"></router-link>
            </div>
            <div class="PlatFormWrap">
                <swiper class="SwiperList1"  :options="swiperOptions1">
                    <swiper-slide class="PlatFormList" v-for="(item, index) in platformList" :key="'platform' + index" ><div class="PlatFormContent flex" @click="OpenSenchaBox(item.type)"><div><img :src="item.icon"><p>{{item.name}}</p></div></div></swiper-slide>
               </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
            <router-link tag="div" :to="{name:'LianWang'}" class="LianWangWrap">
                <img src="../../assets/Buttonicon/h-7.png">
            </router-link>
            <div class="ProductListWrap">
                <div class="Add flexbetween">
                    <router-link tag="i" :to="{name:'Store'}"><img src="../../assets/Buttonicon/h-1.png"></router-link>
                    <router-link tag="i" :to="{name:'StoreList'}"><img src="../../assets/Buttonicon/h-2.png"></router-link>
                </div>
                <div class="ListWrap flexa">
                    <router-link tag="div" :to="{name:'StoreList'}"><img src="../../assets/Buttonicon/h-3.png"></router-link>
                    <router-link tag="div" :to="{name:'StoreList'}"><img src="../../assets/Buttonicon/h-4.png"></router-link>
                    <router-link tag="div" :to="{name:'StoreList'}"><img src="../../assets/Buttonicon/h-5.png"></router-link>
                    <router-link tag="div" :to="{name:'StoreList'}"><img src="../../assets/Buttonicon/h-6.png"></router-link>
                    <div><img src="../../assets/Home/list11.jpg"></div>
                </div>
            </div>
            <div class="bg"><img src="../../assets/Buttonicon/1.jpg"></div>
        </div>
    </div>
</template>
<script>

  import { mapGetters } from 'vuex';
  import axios from 'axios';

  export default {
    name: 'home',
    components: {},
    data() {
      return {
        swiperOptions: {
          slidesPerView: 1.14,
          centeredSlides: true,
          spaceBetween: 15,
          initialSlide: 1,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination'
          }
        },
        swiperOptions1: {
          slidesPerView: 3.4,
          centeredSlides: true,
          spaceBetween: 15,
          initialSlide: 2,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        platformList: [{
          name: 'GE认证平台',
          icon: require('../../assets/Home/icon11.png'),
          info: '统一认证和管理平台所有服务资源，包括:人员、企业、设备、软件等，统一注册、统一认证和统一管理所有平台资源可信数据。',
          type: 'authentication'
        }, {
          name: 'GE配置平台',
          icon: require('../../assets/Home/icon9.png'),
          info: '配置平台用于配置SaaS产品的专属应用系统，充分体现了工易SaaS平台由用户自己配置个性化应用的能力，自我适应企业个性化和变化。平台拥有组织管理器、作业岗位管理器、流程配置器和规则配置器。',
          type: 'manager'
        }, {
          name: 'GE运营平台',
          icon: require('../../assets/Home/icon10.png'),
          info: '运营平台由3个门户和七大板块构成，3个门户包括：WEB门户、APP门户和微信门户，七大板块包括工作、发现、云服务、即时通讯、消息服务、个人中心和工 易云(云服务入口)。',
          type: 'normal'
        }, {
          name: 'GE建模平台',
          icon: require('../../assets/Home/icon8.png'),
          info: '建模平台用于开发SaaS产品的低代码开发平台，平台 拥有主数据管理器、关系管理器、活动管理器、流程 管理器、组件管理器、逻辑管理器、规则管理器等二 十四个管理器和一个JCS开发语言。通过管理器和JCS语言可快速构建和快速迭代SaaS系统。',
          type: 'model'
        }, {
          name: 'GE测试平台',
          icon: require('../../assets/Home/icon12.png'),
          info: '为应用产品开发提供测试服务,通过配置测试环境和模拟使用场景,为应用产品开发和测试人员提供完善的单元测试、集成测试等功能。',
          type: 'test'
        }, {
          name: 'GE监控平台',
          icon: require('../../assets/Home/icon13.png'),
          info: '对工易云PaaS平台管理器工具和SaaS平台应用产品运行所需的软、硬件环境进行实时监控、预警和管理，保障系统稳定运行。',
          type: 'jiankong'
        }]
      };
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'currentSystem'])
    },
    methods: {
      OpenUrl(url) {
        window.open(url, '_blank');
      },
      OpenSenchaBox(type) {
        console.log('123132', this.currentSystem);
        if (type === 'model') {
          this.$store.dispatch('setplatformname', 'PaaS平台');
        } else if (type === 'authentication' || type === 'normal' || type === 'manager' || type === 'test') {
          this.$store.dispatch('setplatformname', 'SaaS平台');
        }
        if (this.LoginUserInfo.userId) {
          if (type === 'authentication' || type === 'normal') { // 认证 运营
            this.$store.dispatch('togglesenchabox', true);
            window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type });
          } else if (type === 'model' || type === 'manager' || type === 'test') { // 建模 配置
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: this.$loginUrl + 'api/login/getnewtoken', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
              params: {
                userid: this.LoginUserInfo.userId, // + '.' + this.LoginUserInfo.username,
                identity: type
              }
            }).then((res) => {
              if (res.data.code === 0) {
                this.$store.dispatch('togglesenchabox', true);
                window.GEVAR.MainController.addInitPage({ user: [res.data.data.user], platform: type, data: res.data.data });
              }
            });
          }
        } else {
          this.$emit('OpenLoginBox');
        }
      }
    }
  };
</script>
<style scoped lang="scss">
@import '../../../public/Value';
.HomeWrap{
    width: 100%;
    .bg{
        width: 100%;
        img{
            width: 87.5%;
            margin: 0 auto;
        }
    }
    .PlatFormWrap{
        width: 100%;
        position: relative;
        .SwiperList1{
            width: 100%;
            margin: 0.15rem auto 0.1rem;
            .PlatFormContent{
                width: 100%;
                height:1.05rem;
                margin-right: 0.05rem;
                cursor: pointer;
                background-color: #7f66aa;
                border-radius: 0.1rem;
                img{
                    width: 0.23rem;
                    margin: 0 auto;
                }
                p{
                    width: 100%;
                    text-align: center;
                    color: #fff;
                    font-size: $TextSize;
                    margin-top: 0.1rem;
                    font-weight: bold;
                }
            }
        }
    }
    .SwiperWrap {
        width: 100%;
        height: 1.3rem;
        position: relative;
        overflow: hidden;
        .swiper-pagination {
            width: 100%;
            height: 0.1rem;
            position: absolute;
            bottom: 0.02rem;
            ::v-deep .swiper-pagination-bullet-active {
                background-color: #fff !important;
            }
           ::v-deep .swiper-pagination-bullet {
                width: 0.15rem;
                height: 0.02rem;
                opacity: 1;
                margin: 0 0.02rem;
                background-color: #4d4d4d;
                border-radius: 0.03rem;
            }
        }

        .LeftShadow, .RightShadow {
            height: 100%;
            position: absolute;
            z-index: 2;

            img {
                height: 100%;
                transform: scale(1.1);
            }
        }

        .LeftShadow {
            left: -0.1rem;
            top: 0;
        }

        .RightShadow {
            right: -0.1rem;
            top: 0;
        }

        .SwiperList {
            width: 100%;
            height: 100%;

            .ImgWrap {
                border-radius: 0.1rem;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 0.1rem;
                }
            }
        }
    }
    .HomeContentWrap{
        width: 100%;
        .LianWangWrap{
            width: 88%;
            margin: 0.15rem auto 0.1rem;
            cursor: pointer;
            img{
                width: 100%;
            }
        }
        .ListWrap{
            width: 88%;
            margin: 0.15rem auto 0.1rem;
            div{
                width: 0.62rem;
                height:0.62rem;
                margin-right: 0.05rem;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            div:last-child{
                margin-right: 0;
            }
        }
       .ProductListWrap{
           width: 100%;
           .ListWrap{
               width: 88%;
               margin: 0.05rem auto 0;
               div{
                   width: 0.62rem;
                   height:0.62rem;
                   margin-right: 0.05rem;
                   cursor: pointer;
                   img {
                       width: 100%;
                       height: 100%;
                       object-fit: cover;
                   }
               }
               div:last-child{
                   margin-right: 0;
               }
           }
           .Add{
               width: 88%;
               margin: 0.2rem auto 0;
               i:first-child{
                   width: 1rem;
                   height: 1rem;
                   cursor: pointer;
                   img{
                       width: 100%;
                       height: 100%;
                       object-fit: cover;
                       border-radius: 0.08rem;
                   }
               }
               i:nth-child(2){
                   width: 2.2rem;
                   height: 1rem;
                   position: relative;
                   cursor: pointer;
                   div{
                       position: absolute;
                       width: 1.3rem;
                       top:0.7rem;
                       left: 0.15rem;
                       p{
                           font-style: normal;
                       }
                       p:first-child{
                           font-size: $TextSize;
                           font-weight: bold;
                           color: #fff;
                       }
                       p:nth-child(2){
                           font-size: $AdditionTextSize;
                           color: #fff;
                           margin-top: 0.02rem;
                       }
                   }
                   img{
                       width: 100%;
                       height: 100%;
                       object-fit: cover;
                       border-radius: 0.08rem;
                   }
               }
           }
       }
    }
}
</style>
